import { HttpEventType } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ProgressStatus, ProgressStatusEnum } from 'src/models/progress-status.model';
import { ShareDataService } from 'src/providers/sharedata.service';
import { UploadDownloadService } from '../file-upload/upload-download.service';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit {

  imgUpload: any;
  previews: string[] = [];
  selectedFiles?: FileList;
  imgPreview = document.getElementById('img_preview');
  imgUploadForm = document.getElementById('img-upload-form');
  totalFiles: any;
  previewTitle: any;
  previewTitleText: any;
  img: any;
  sliders: object[];
  
  @Input() public disabled: boolean;
  @Output() public uploadStatus: EventEmitter<ProgressStatus>;
  @ViewChild('inputFile') inputFile: ElementRef;
  @Output() public showUploadState: any;
    DateNow: string;

  constructor(public service: UploadDownloadService,public share: ShareDataService,private sanitizer: DomSanitizer,public dialog: MatDialog) { 
    this.uploadStatus = new EventEmitter<ProgressStatus>();
  }

  ngOnInit(): void {
    this.date();
    this.sliders = [
      {'name': 'slider1', 'src': '/1'},
      {'name': 'slider2', 'src': '/2'},
      {'name': 'slider3', 'src': '/3'},
      {'name': 'slider4', 'src': '/4'},
      {'name': 'slider5', 'src': '/5'},
      {'name': 'slider6', 'src': '/6'}
    ]
  }

previewImgs(event) {
  this.totalFiles = this.imgUpload.files;
  
  if(!!this.totalFiles) {
    this.imgPreview.classList.remove('quote-imgs-thumbs--hidden');
    this.previewTitle = document.createElement('p');
    this.previewTitle.style.fontWeight = 'bold';
    this.previewTitleText = document.createTextNode(this.totalFiles + ' Total Images Selected');
    this.previewTitle.appendChild(this.previewTitleText);
    this.imgPreview.appendChild(this.previewTitle);
  }
  
  for(var i = 0; i < this.totalFiles; i++) {
    this.img = document.createElement('img');
    this.img.src = URL.createObjectURL(event.target.files[i]);
    this.img.classList.add('img-preview-thumb');
    this.imgPreview.appendChild(this.img);
  }
}

selectFiles(event: any): void {
  this.selectedFiles = event.target.files;

  this.previews = [];
  if (this.selectedFiles && this.selectedFiles[0]) {
    const numberOfFiles = this.selectedFiles.length;
    for (let i = 0; i < numberOfFiles; i++) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        this.previews.push(e.target.result);
      };

      reader.readAsDataURL(this.selectedFiles[i]);
    }
  }
}

public upload(event, action: string, sdata: string) {
  if (event.target.files && event.target.files.length > 0) {
    const file = event.target.files[0];
    this.service.setPath(this.sanitizer.bypassSecurityTrustUrl(file));
    this.uploadStatus.emit( {status: ProgressStatusEnum.START});
    this.service.uploadFile(file, action, sdata).subscribe(
      data => {
        if (data && data.type !== 0) {
          switch (data.type) {
            case HttpEventType.UploadProgress:
              this.uploadStatus.emit( {status: ProgressStatusEnum.IN_PROGRESS, percentage: Math.round((data.loaded / data.total) * 100)});
              break;
            case HttpEventType.Response:
              this.date();
              this.inputFile.nativeElement.value = '';
              this.uploadStatus.emit( {status: ProgressStatusEnum.COMPLETE});
              //this.showUploadState = "حجم فایل های آپلود شده بیشتر از حد مجاز است!";
              break;
          }
        }
      },
      error => {
        this.inputFile.nativeElement.value = '';
        this.uploadStatus.emit( {status: ProgressStatusEnum.ERROR});
      }
    );
  }
}

date(): void { this.DateNow = `?${Date.now()}`; }

}
